import { render, staticRenderFns } from "./admin.content.vue?vue&type=template&id=9c268f0e&"
import script from "./admin.content.vue?vue&type=script&lang=js&"
export * from "./admin.content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports